/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationRemoteSessionClientDeletePreflightSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetOrganizationRemoteSessionClientDeletePreflightRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetOrganizationRemoteSessionClientDeletePreflightSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
    "apikey_header_Gram-Key"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionClientDeletePreflightSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionClientDeletePreflightSecurity$Outbound,
    GetOrganizationRemoteSessionClientDeletePreflightSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionClientDeletePreflightSecurityToJSON(
  getOrganizationRemoteSessionClientDeletePreflightSecurity:
    GetOrganizationRemoteSessionClientDeletePreflightSecurity,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionClientDeletePreflightSecurity$outboundSchema
      .parse(getOrganizationRemoteSessionClientDeletePreflightSecurity),
  );
}

/** @internal */
export type GetOrganizationRemoteSessionClientDeletePreflightRequest$Outbound =
  {
    id: string;
    "Gram-Session"?: string | undefined;
    "Gram-Key"?: string | undefined;
  };

/** @internal */
export const GetOrganizationRemoteSessionClientDeletePreflightRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionClientDeletePreflightRequest$Outbound,
    GetOrganizationRemoteSessionClientDeletePreflightRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionClientDeletePreflightRequestToJSON(
  getOrganizationRemoteSessionClientDeletePreflightRequest:
    GetOrganizationRemoteSessionClientDeletePreflightRequest,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionClientDeletePreflightRequest$outboundSchema
      .parse(getOrganizationRemoteSessionClientDeletePreflightRequest),
  );
}
